import dayjs, { QUnitType, ConfigType } from 'dayjs'

export const formatDate = (
  date: ConfigType,
  formateType = 'DD MMM YYYY, HH:mm',
  dafaultValue = '',
) => (date ? dayjs(date).format(formateType) : dafaultValue)

export const diffDate = (date1: ConfigType, date2: ConfigType, unit: QUnitType) =>
  dayjs(date1).diff(date2, unit)

export const formatUnixDate = (
  date: number | string,
  formateType = 'DD MMM YYYY, HH:mm',
  dafaultValue = '',
) => (date ? dayjs.unix(Number(date)).format(formateType) : dafaultValue)
